import {connect, useSelector} from "react-redux";
import {
    CButton,
    CButtonGroup,
    CCol, CForm,
    CFormInput,
    CFormSelect,
    CInputGroup,
    CInputGroupText,
    CRow
} from "@coreui/react";
import React, {useEffect, useState} from "react";
import * as api from "../../../api/api";
import {selectedActions} from "../../../redux-store/actions/selected";
import {storeActions} from "../../../redux-store/actions/store";
import * as o2Api from "../../../api/api";

const PopupStoreCornerListWhere = (props) => {
    const [company, setCompany] = useState([{cmpCd: "", cmpNm: "전체"}]);
    const [brand, setBrand] = useState([{brandCd: "", brandNm: "전체"}]);
    const [store, setStore] = useState([{storeCd: "", storeNm: "전체"}]);
    const [corner, setCorner] = useState([{cornerCd: "", cornerNm: "전체"}]);
    const [searchStore, setSearchStore] = useState("");

    useEffect(() => {
        getCompany();
    }, []);

    const getCompany = async () => {
        const {data: result} = await api.getCompany(props.selected.cmpCd);
        const {responseBody, responseCode, responseMessage} = result;
        if (responseCode === "200") {
            // 성공
            setCompany([responseBody]);
            getBrand(props.selected.cmpCd);
        }
    };

    const getBrand = async (cmpCd) => {
        const {data: result} = await api.getBrand(cmpCd, props.selected.brandCd);
        const {responseBody, responseCode, responseMessage} = result;
        if (responseCode === "200") {
            // 성공
            setBrand([responseBody]);
            getStore(cmpCd, props.selected.brandCd);
        }
    };

    const getStore = async (cmpCd, brandCd) => {
        const params = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            storeCd: props.selected.storeCd,
            manageDiv: "0",
            userId: 'restadmin'
        };

        const {data: result} = await api.getStoreWhere(params);
        const {responseBody, responseCode, responseMessage} = result;
        if (responseCode === "200") {
            if (responseBody != null) {
                // 성공
                setStore(responseBody);
                getCorner(cmpCd, brandCd, props.selected.storeCd);
            }
        }
    };

    const getCorner = async (cmpCd, brandCd, storeCd) => {
        const params = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            storeCd: storeCd
        };

        const {data: result} = await o2Api.getStoreCorner(params);
        const {responseBody, responseCode, responseMessage} = result;
        if (responseCode === "200") {
            if (responseBody != null) {
                // 성공
                setCorner([{cornerCd: "", cornerNm: "전체"}]);
                setCorner((state) => state.concat(responseBody));
            }
        }
    };

    const handleSelect = (e, value) => {
        if (value === "C") {
            props.onSelect(e.target.value, "C");
            props.setSelectCmpCd(e.target.value);
            if (e.target.value !== '') {
                getBrand(e.target.value);
            }
            else {
                props.setSelectBrandCd("");
                setBrand([{brandCd: "", brandNm: "전체"}]);
                props.setSelectStoreCd("");
                setStore([{storeCd: "", storeNm: "전체"}]);

                // 코너는 현재 redux에 담지 않음
                setCorner([{cornerCd: "", cornerNm: "전체"}]);
            }
        } else if (value === "B") {
            props.onSelect(e.target.value, "B");
            props.setSelectBrandCd(e.target.value);
            if (e.target.value !== '') {
                getStore(props.selected.cmpCd, e.target.value);
            }
            else {
                props.setSelectStoreCd("");
                setStore([{storeCd: "", storeNm: "전체"}]);

                // 코너는 현재 redux에 담지 않음
                setCorner([{cornerCd: "", cornerNm: "전체"}]);
            }
        } else if (value === "S") {
            props.onSelect(e.target.value, "S");
            props.setSelectStoreCd(e.target.value);
            if (e.target.value !== '') {
                getCorner(props.selected.cmpCd, props.selected.brandCd, e.target.value)
            }
            else {
                setCorner([{cornerCd: "", cornerNm: "전체"}]);
            }
        } else if (value === "O") {
            props.onSelect(e.target.value, "O");
        }
    };

    return (
        <>
            <CForm className={"row row-cols-lg-auto g-1 align-items-center p-1"}>
            <CCol xs={12}>
                <CInputGroup size="sm">
                    <CInputGroupText style={{width: 70}}>운영사</CInputGroupText>
                    <CFormSelect id="company"
                                 value={props.selected.cmpCd}
                                 onChange={(e) => handleSelect(e, "C")}>
                        {company.map((item, index) => {
                            return (
                                <option key={index} value={item.cmpCd}>{item.cmpNm}</option>
                            );
                        })}
                    </CFormSelect>
                </CInputGroup>
            </CCol>
            <CCol xs={12}>
                <CInputGroup size="sm">
                    <CInputGroupText style={{width: 70}}>휴게소</CInputGroupText>
                    <CFormSelect id="brand"
                                 value={props.selected.brandCd}
                                 onChange={(e) => handleSelect(e, "B")}>
                        {brand.map((item, index) => {
                            return (
                                <option key={index} value={item.brandCd}>{item.brandNm}</option>
                            );
                        })}
                    </CFormSelect>
                </CInputGroup>
            </CCol>
            {(props.type === "S" || props.type === "O") &&
            <CCol xs={12}>
                <CInputGroup size="sm">
                    <CInputGroupText style={{width: 70}}>매장</CInputGroupText>
                    <CFormSelect id="store"
                                 value={props.selected.storeCd}
                                 onChange={(e) => handleSelect(e, "S")}>
                        {store.map((item, index) => {
                            return (
                                <option key={index} value={item.storeCd}>{item.storeNm}</option>
                            );
                        })}
                    </CFormSelect>
                </CInputGroup>
            </CCol>
            }
            {(props.type === "O") &&
            <CCol xs={12}>
                <CInputGroup size="sm">
                    <CInputGroupText style={{width: 70}}>코너</CInputGroupText>
                    <CFormSelect id="corner"
                                 value={corner.cornerCd}
                                 onChange={(e) => handleSelect(e, "O")}>
                        {corner.map((corner, index) => {
                            return (
                                <option key={index} value={corner.cornerCd}>{corner.cornerNm}</option>
                            );
                        })}
                    </CFormSelect>
                </CInputGroup>
            </CCol>
            }
            </CForm>
        </>
    );
}

export default connect(null, null)(PopupStoreCornerListWhere);
